import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IQuizState } from ".";
import { IQuizTheme } from "./get-quiz.handler";

export interface IGetQuizThemesResponse {
    themes: IQuizTheme[];
    ignoreThemeIds: number[];
}

export const getQuizThemes = createAsyncThunk<IGetQuizThemesResponse, number[]>(
    'quiz.getQuizThemes',
    async (ignoreThemeIds: number[]) => await api.quizzes.getThemes(ignoreThemeIds)
);

const getQuizThemesHandler = (builder: ActionReducerMapBuilder<IQuizState>) => {
    builder
        .addCase(getQuizThemes.pending, (state: IQuizState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getQuizThemes.fulfilled, (state: IQuizState, action: PayloadAction<IGetQuizThemesResponse>) => {
            state.loading = false;
            if (action.payload?.themes?.length)
                state.themes = action.payload?.themes;

            state.ignoreThemeIds = action.payload?.ignoreThemeIds ?? [];            
        })
        .addCase(getQuizThemes.rejected, (state: IQuizState) => {
            state.loading = false;
            state.error = 'Unable to get quiz themes';
        });
};

export default getQuizThemesHandler;